import React from "react";
import { Link } from "react-router-dom";

const Btn = ({
    children,
    to = "",
    target,
    rel,
    routePrefix = "",
    style,
    needle = true,
    className,
}) => {
    if (to.startsWith("/")) {
        return (
            <Link
                to={routePrefix ? routePrefix + to : to}
                className={`btn ${className}`}
                style={style}
            >
                {needle && (
                    <img
                        src={process.env.PUBLIC_URL + "/images/btn-needle.png"}
                        className="btn__needle"
                        alt="btn needle"
                    />
                )}
                {children}
            </Link>
        );
    } else {
        return (
            <a
                href={to}
                target="_blank"
                rel="noreferrer"
                style={style}
                className={`btn ${className}`}
            >
                {needle && (
                    <img
                        src={process.env.PUBLIC_URL + "/images/btn-needle.png"}
                        className="btn__needle"
                        alt="btn needle"
                    />
                )}
                {children}
            </a>
        );
    }
};

export default Btn;
